export default "__VITE_ASSET__ac0db659__"